// extracted by mini-css-extract-plugin
module.exports = {"productExpandContainer":"ImageZoomModal_productExpandContainer__V3vDT"};